"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateGetDecksResult = void 0;
const validation_1 = require("@fmtk/validation");
const DeckResult_1 = require("./DeckResult");
exports.validateGetDecksResult = (0, validation_1.array)(DeckResult_1.validateDeckResult);
//# sourceMappingURL=GetDecksResult.js.map